/**
 * Performance Screen
 *
 * Displays historical supplier performance statistics: current,
 * average, maximum, and standard deviation of delinquency ratio,
 * dilution ratio, and DSO. Data is fetched from the Python backend
 * on mount. A hidden "Calculate" button exists for manual recalculation.
 */
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "Components/DataTable";
// -------------------------------------------------------------
import { getPerformanceData } from "Redux/performance/actions";
import { calculateAny } from "Redux/data/actions";

// -------------------------------------------------------------
// Column definitions — Each metric has current/avg/max/std variants.
// Percentage display is applied to ratio columns.
// -------------------------------------------------------------

const headers = [
  { text: "Supplier", key: "Supplier", datatype: "string" },
  {
    text: "Current Supplier Delinquency Ratio",
    key: "Supplier Delinquency Ratio",
    datatype: "float",
    display: "percentage",
  },
  {
    text: "Avg Delinquency Ratio",
    key: "Avg Delinquency Ratio",
    datatype: "float",
    display: "percentage",
  },
  {
    text: "Max Delinquency Ratio",
    key: "Max Delinquency Ratio",
    datatype: "float",
    display: "percentage",
  },
  {
    text: "Std Delinquency Ratio",
    key: "Std Delinquency Ratio",
    datatype: "float",
    display: "percentage",
  },
  {
    text: "Current Supplier Dilution Ratio",
    key: "Supplier Dilution Ratio",
    datatype: "float",
    display: "percentage",
  },
  {
    text: "Avg Dilution Ratio",
    key: "Avg Dilution Ratio",
    datatype: "float",
    display: "percentage",
  },
  {
    text: "Max Dilution Ratio",
    key: "Max Dilution Ratio",
    datatype: "float",
    display: "percentage",
  },
  {
    text: "Std Dilution Ratio",
    key: "Std Dilution Ratio",
    datatype: "float",
    display: "percentage",
  },
  { text: "Current Supplier DSO", key: "Supplier DSO", datatype: "float" },
  { text: "Avg DSO", key: "Avg DSO", datatype: "float" },
  { text: "Max DSO", key: "Max DSO", datatype: "float" },
  { text: "Std DSO", key: "Std DSO", datatype: "float" },
];

// -------------------------------------------------------------
// -------------------------------------------------------------
const Performance = () => {
  const dispatch = useDispatch();
  const [calculating, setCalculating] = useState(false);

  useEffect(() => {
    dispatch(getPerformanceData(() => {}));
  }, [dispatch]);

  const { performance } = useSelector((state) => state.performance);

  return (
    <div>
      {false && (
        <button
          className={`button is-small ${calculating ? "is-loading" : ""}`}
          onClick={() => {
            setCalculating(true);
            dispatch(
              calculateAny("performance", () => {
                setCalculating(false);
              })
            );
          }}
        >
          Calculate
        </button>
      )}
      {performance && (
        <DataTable
          data={performance.data}
          headers={headers}
          reference="Supplier"
        />
      )}
    </div>
  );
};

export default Performance;
